var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.item.hidden)?_c('base-item-group',{attrs:{"item":_vm.item,"text":"","sub-group":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }